import Offers from '../components/offers';

import useCampaignData from '../hooks/useCampaignData';
import useProductInformation from '../hooks/useProductInformation';
import Layout from '../components/layout';
import useFooterData from '../hooks/useFooterData';
import { JSX } from 'preact';

const CampaignPage = ({ storefrontConfig }): JSX.Element => {
    const campaignData = useCampaignData();
    const productInfo = useProductInformation();
    const footerData = useFooterData(campaignData, storefrontConfig);
    if (campaignData.loading || productInfo.loading) {
        return <div />;
    }

    return (
        <Layout campaignData={campaignData} storefrontConfig={storefrontConfig} footerData={footerData}>
            {/* @ts-ignore */}
            <Offers campaignData={campaignData.data} productPrices={productInfo.data.prices} />
        </Layout>
    );
};

export default CampaignPage;
